module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/text-e974d9f21162c187fd00bfc8e5aa752c.svg";